/* eslint-disable import/prefer-default-export */
export const groupData = [
  {
    link: 'Batting',
    name: 'Batting',
    is_active: 'true',
  },
  {
    link: 'Bowling',
    name: 'Bowling',
    is_active: 'false',
  },
  {
    link: 'Fielding',
    name: 'Fielding',
    is_active: 'false',
  },
  {
    link: 'Team',
    name: 'Team',
    is_active: 'false',
  },
];

export const statsValueMap = {
  1: 'highest_score',
  2: 'runs_scored',
  3: 'average',
  4: 'batting_strike_rate',
  5: 'fifties',
  6: 'hundred',
  7: 'fours',
  8: 'sixes',
  51: 'partnership_runs',
  12: 'best_bowling_figures',
  13: 'wickets',
  14: 'bowling_strike_rate',
  15: 'best_bowling_average',
  16: 'economy',
  17: 'five_wickets_haul',
  58: 'dot balls',
  21: 'most_catches',
  22: 'most_run_outs',
  23: 'most_dismissals',
  24: 'highest_team_total',
  25: 'lowest_team_total',
};
export const statsValueMapCategory = {
  '1': 'Batting',
  '2': 'Batting',
  '3': 'Batting',
  '4': 'Batting',
  '5': 'Batting',
  '6': 'Batting',
  '7': 'Batting',
  '8': 'Batting',
  '12': 'Bowling',
  '13': 'Bowling',
  '14': 'Bowling',
  '15': 'Bowling',
  '16': 'Bowling',
  '17': 'Bowling',
  '21': 'Fielding',
  '22': 'Fielding',
  '23': 'Fielding',
  '24': 'Team',
  '25': 'Team',
  '51': 'Batting',
  '58': 'Bowling',
};

export const statsTableHeaderMap = {
  1: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    highest_score: 'H.Score',
    balls_faced: 'Balls',
    batting_strike_rate: 'SR.',
    vs_team_name: 'vs Team',
  },
  2: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    runs_scored: 'Runs',
    matches_played: 'M',
    innings_played: 'Inn',
    batting_strike_rate: 'SR',
    average: 'Avg',
  },
  3: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    average: 'Avg',
    matches_played: 'M',
    innings_played: 'Inn',
    runs_scored: 'Runs',
  },
  4: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    batting_strike_rate: 'SR.',
    matches_played: 'M',
    innings_played: 'Inn',
    runs_scored: 'Runs',
  },
  5: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    fifties: '50s',
    matches_played: 'M',
    innings_played: 'Inn',
    runs_scored: 'Runs',
  },
  6: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    hundred: '100s',
    matches_played: 'M',
    innings_played: 'Inn',
    runs_scored: 'Runs',
  },
  7: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    fours: '4s',
    matches_played: 'M',
    innings_played: 'Inn',
    runs_scored: 'Runs',
  },
  8: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    sixes: '6s',
    matches_played: 'M',
    innings_played: 'Inn',
    runs_scored: 'R',
  },
  51: {
    Batsman1_Name: 'Name',
    Batsman2_Name: '',
    partnership_balls_faced: 'Balls',
    For_Team: 'Team',
    Against_Team: 'vs Team',
  },
  12: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    best_bowling_figures: 'Best',
    overs: 'Ovs',
    runs_given: 'R',
    vs_team_name: 'vs Team',
  },
  13: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    wickets: 'Wkts',
    matches_played: 'M',
    overs: 'Ovs',
    economy: 'ER',
    best_bowling_average: 'Avg',
  },
  14: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    bowling_strike_rate: 'SR.',
    matches_played: 'M',
    overs: 'Ovs',
    wickets: 'Wkts',
  },
  15: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    best_bowling_average: 'Avg',
    matches_played: 'M',
    overs: 'Ovs',
    wickets: 'Wkts',
  },
  16: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    economy: ' ER.',
    matches_played: 'M',
    overs: 'Ovs',
    wickets: 'Wkts',
  },
  17: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    five_wickets_haul: '5 Wkt(s)',
    matches_played: 'M',
    overs: 'Ovs',
    wickets: 'Wkts',
  },
  58: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    dot_balls: 'Dots',
    matches_played: 'M',
    overs: 'Ovs',
    wickets: 'Wkts',
  },
  21: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    most_catches: 'CTs',
    matches_played: 'M',
  },
  22: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    most_run_outs: 'Run Outs',
    matches_played: 'M',
  },
  23: {
    player_pic: '',
    player_name: 'Name',
    team_short_name: '',
    most_dismissals: 'DIS',
    matches_played: 'M',
    most_catches: 'CTs',
    most_stumpings: 'ST',
  },
  24: {
    team_name: 'Name',
    team_short_name: '',
    highest_team_total: 'Total',
    vs_team_name: 'vs Team',
    match_date: 'Date',
  },
  25: {
    team_name: 'Name',
    team_short_name: '',
    lowest_team_total: 'Total',
    vs_team_name: 'vs Team',
    match_date: 'Date',
  },
};
